module.exports = __webpack_public_path__ + "img/img_main_tit.2aa4857e.png";